<template>
<span>
  <v-icon dark>{{done?'done':'brush'}}</v-icon>
</span>
</template>
<script>
export default {
  name: 'sign-icon',
  props: {
    done: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="stylus" scoped></style>
